import { navigate } from 'gatsby'

import type { Locale } from '@application/Types/Locale'
import { languages } from '@src/Application/Constants/languageConstants'
import { getAlternativePageUrl, onChangeLanguage } from '@src/Application/Interfaces/Organisms/LanguageMenu/utils'
import { AlternateUrlType, HeaderThemeModeType } from '@src/Application/Types/ComponentTypes'
import { HeaderNav } from '@src/Application/Types/HeaderTypes'
import { Nullable } from '@src/Application/Types/Opt'
import { sortingArray } from '@src/Application/Utils/generalUtils'

type ToggleMenu = (setIsExpanded: (isExpanded: boolean) => void, value: boolean) => () => void
export const toggleMenu: ToggleMenu = (setIsExpanded, value) => () => {
    setIsExpanded(value)
}

type GetNatItem = (nodes: HeaderNav[], value: string) => HeaderNav[]
export const getNavNode: GetNatItem = (nodes, value) =>
    nodes.filter((node) => node.position === value).sort(sortingArray((data) => data.order))

type GetLastNavNode = (nodes: HeaderNav[]) => Nullable<HeaderNav>
export const getLastNavNode: GetLastNavNode = (node) => (node.length > 0 ? node[node.length - 1] : null)

type GetMobileNav = ({
    leftItems,
    rightItems,
    language,
    languageLabel,
    alternateUrls,
}: {
    leftItems: HeaderNav[]
    rightItems: HeaderNav[]
    language: Locale
    languageLabel: string
    alternateUrls?: Nullable<AlternateUrlType[]>
    organizationLanguages: Locale[]
}) => HeaderNav[]

export const getMobileNav: GetMobileNav = ({
    leftItems,
    rightItems,
    language,
    languageLabel,
    alternateUrls,
    organizationLanguages,
}) => {
    const totalItem = leftItems.length + rightItems.length

    const lngs = languages.filter((lang) => organizationLanguages.includes(lang.locale))

    const languageMenuItem: HeaderNav = {
        language,
        link: '',
        label: languageLabel,
        submenu: [
            {
                id: `${totalItem + 1}`,
                strapi_component: 'dynamic-columns',
                menuLinkSections: [
                    {
                        buttonLabel: null,
                        buttonStyle: null,
                        buttonUrl: null,
                        title: null,
                        link: lngs.map((item) => ({
                            name: item.name,
                            onClick: onChangeLanguage(
                                item.locale,
                                navigate,
                                getAlternativePageUrl(language, alternateUrls)
                            ),
                        })),
                        publishedAt: null,
                    },
                ],
            },
        ],
        position: 'right',
        order: totalItem,
    }
    return [...leftItems, languageMenuItem, ...rightItems]
}

export const getColorBasedMode = (mode: HeaderThemeModeType): string => (mode === 'Light' ? 'black' : 'white')
